module.exports = __webpack_public_path__ + "img/slack-circle.dc8159e3.svg";